export const appendStrings = (string, stringToAppend, separator = " ") => {
	return string + separator + stringToAppend;
};